import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

export default function CancelPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="p-6 min-h-[60vh] flex items-center justify-center">
      <div className="max-w-md w-full text-center">
        <AlertCircle className="w-14 h-14 text-farm-warning mx-auto mb-4" />
        <h1 className="font-heading text-xl font-bold mb-2">{t('subscriptionCancel.title')}</h1>
        <p className="text-sm text-muted-foreground mb-6">{t('subscriptionCancel.body')}</p>
        <div className="flex gap-3 justify-center">
          <Button variant="outline" onClick={() => navigate('/dashboard', { replace: true })}>
            {t('subscriptionCancel.backToDashboard')}
          </Button>
          <Button onClick={() => navigate('/subscription/plans', { replace: true })}>
            {t('subscriptionCancel.backToPlans')}
          </Button>
        </div>
      </div>
    </div>
  );
}
